import { ref } from 'vue';

const ready = ref(false);

export const useBudgetEntryDrawer = () => ({
    ready,
});
